import { General } from '../../../data-objects/units/Army';

export function computeEpForGeneral(baseEp: number, general: General) {
  const { bonusExp } = general;
  const expMultiplicator = 1 + (bonusExp ?? 0) / 100;
  return Math.floor(baseEp * expMultiplicator);
}
